import { NoteSearchResponse } from '@lio/api-types';
import { ArrayItem } from '@utils/commonTypes';

export type Notes = NoteSearchResponse['items'];
export type Artifact = ArrayItem<ArrayItem<NoteSearchResponse['items']>['artifacts']>;
export type Note = ArrayItem<NoteSearchResponse['items']> & {
  filterText?: string;
};

export enum NoteType {
  Note = 'Note',
  Message = 'Message',
}

export enum MediaType {
  Image = 'IMAGE',
  Video = 'VIDEO',
  Document = 'DOCUMENT',
}

export interface PostArtifact {
  description: string;
  type: MediaType;
  file: File;
  name: string;
  mimetype: string;
  size: number;
  invalidMsg: string | null;
}
